(function () {
  'use strict';

  var STORAGE_KEY = 'qala_currency';
  var RATES_CACHE_KEY = 'qala_currency_rates';
  var RATES_TTL_MS = 12 * 60 * 60 * 1000; // 12 hours
  var PRICE_REGEX = /Rs\.\s?([\d,]+\.\d{2})/g;
  var PINNED = ['INR', 'USD', 'GBP', 'EUR', 'AED', 'AUD', 'CAD', 'SGD'];

  var currentCode = 'INR';
  var rates = null; // { CODE: ratePerINR }

  function getBaseCurrency(el) {
    return (el && el.getAttribute('data-shop-currency')) || 'INR';
  }

  function loadCachedRates() {
    try {
      var raw = localStorage.getItem(RATES_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.rates || !parsed.fetchedAt) return null;
      if (Date.now() - parsed.fetchedAt > RATES_TTL_MS) return parsed.rates; // stale but usable while refreshing
      return parsed.rates;
    } catch (e) {
      return null;
    }
  }

  function saveCachedRates(r) {
    try {
      localStorage.setItem(RATES_CACHE_KEY, JSON.stringify({ rates: r, fetchedAt: Date.now() }));
    } catch (e) {
      /* ignore */
    }
  }

  function fetchRates(base) {
    return fetch('https://open.er-api.com/v6/latest/' + base)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data && data.result === 'success' && data.rates) {
          saveCachedRates(data.rates);
          return data.rates;
        }
        throw new Error('rate fetch failed');
      });
  }

  function formatMoney(amount, code) {
    try {
      var digits = amount >= 1000 ? 0 : 2;
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return code + ' ' + amount.toFixed(2);
    }
  }

  var applying = false;

  function convertNode(textNode, base) {
    var pricePattern = textNode.parentElement.closest('header a[href*="filter.v.price."]')
      ? /(?:Rs\.\s?|₹\s?)([\d,]+(?:\.\d{2})?)/g
      : PRICE_REGEX;
    var original = textNode.__qalaOriginal;
    if (original === undefined) {
      if (textNode.nodeValue.match(pricePattern)) {
        original = textNode.nodeValue;
        textNode.__qalaOriginal = original;
      } else {
        return;
      }
    }

    if (currentCode === base || !rates || !rates[currentCode]) {
      if (textNode.nodeValue !== original) textNode.nodeValue = original;
      return;
    }

    var rate = rates[currentCode];
    var replaced = original.replace(pricePattern, function (_, num) {
      var amount = parseFloat(num.replace(/,/g, ''));
      if (isNaN(amount)) return _;
      var converted = amount * rate;
      return formatMoney(converted, currentCode);
    });

    if (textNode.nodeValue !== replaced) textNode.nodeValue = replaced;
  }

  function walk(root, base) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    var nodes = [];
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(function (n) {
      convertNode(n, base);
    });
  }

  function applyConversion(base) {
    if (applying) return;
    applying = true;
    walk(document.body, base);
    applying = false;
  }

  function buildCurrencyList() {
    if (!rates) return PINNED.slice();
    var codes = Object.keys(rates);
    var rest = codes.filter(function (c) {
      return PINNED.indexOf(c) === -1;
    });
    rest.sort();
    return PINNED.filter(function (c) {
      return codes.indexOf(c) !== -1;
    }).concat(rest);
  }

  function symbolFor(code) {
    try {
      var parts = new Intl.NumberFormat(undefined, { style: 'currency', currency: code })
        .formatToParts(1);
      var sym = parts.find(function (p) {
        return p.type === 'currency';
      });
      return sym ? sym.value : code;
    } catch (e) {
      return code;
    }
  }

  function CurrencySwitcher() {}

  function init(el) {
    var base = getBaseCurrency(el);
    var toggle = el.querySelector('.qala-currency-switcher__toggle');
    var panel = el.querySelector('.qala-currency-switcher__panel');
    var search = el.querySelector('.qala-currency-switcher__search');
    var list = el.querySelector('.qala-currency-switcher__list');
    var codeLabel = el.querySelector('.qala-currency-switcher__code');

    currentCode = (function () {
      try {
        return localStorage.getItem(STORAGE_KEY) || base;
      } catch (e) {
        return base;
      }
    })();

    function setLabel(code) {
      codeLabel.textContent = code;
    }

    function renderList(filter) {
      var codes = buildCurrencyList();
      if (filter) {
        var f = filter.toLowerCase();
        codes = codes.filter(function (c) {
          return c.toLowerCase().indexOf(f) !== -1;
        });
      }
      list.innerHTML = '';
      codes.forEach(function (code) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'qala-currency-switcher__option';
        btn.setAttribute('role', 'option');
        btn.setAttribute('data-code', code);
        if (code === currentCode) btn.setAttribute('aria-selected', 'true');
        btn.innerHTML =
          '<span>' + code + '</span><span class="qala-currency-switcher__option-symbol">' + symbolFor(code) + '</span>';
        btn.addEventListener('click', function () {
          currentCode = code;
          try {
            localStorage.setItem(STORAGE_KEY, code);
          } catch (e) {
            /* ignore */
          }
          setLabel(code);
          closePanel();
          applyConversion(base);
        });
        li.appendChild(btn);
        list.appendChild(li);
      });
    }

    function openPanel() {
      panel.hidden = false;
      el.setAttribute('open', '');
      toggle.setAttribute('aria-expanded', 'true');
      renderList('');
      search.value = '';
      setTimeout(function () {
        search.focus();
      }, 0);
    }

    function closePanel() {
      panel.hidden = true;
      el.removeAttribute('open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.hidden) openPanel();
      else closePanel();
    });

    search.addEventListener('input', function () {
      renderList(search.value);
    });

    document.addEventListener('click', function (e) {
      if (!el.contains(e.target)) closePanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

    setLabel(currentCode);

    function boot(r) {
      rates = r;
      setLabel(currentCode);
      applyConversion(base);
      renderList(search.value);
    }

    var cached = loadCachedRates();
    if (cached) boot(cached);

    fetchRates(base)
      .then(boot)
      .catch(function () {
        /* keep cached/base state on failure */
      });

    var mo = new MutationObserver(function () {
      if (applying) return;
      applyConversion(base);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('currency-switcher.qala-currency-switcher');
    els.forEach(init);
  });
})();
